/**
 * Created by bartdecorte on 04/05/2017.
 */

class Password {
  constructor(params) {
    this.active = false;
    this.params = {
      $element: params.$element,
    };
    this.bindListeners();
  }

  bindListeners() {
    this.params.$element.on('click', '.js-btn-show', (ev) => {
      return this.lButtonShowClicked(ev);
    });
    this.params.$element.on('click', '.js-btn-generate', (ev) => {
      return this.lButtonGenerateClicked(ev);
    });
  }

  lButtonShowClicked(ev) {
    ev.preventDefault();
    this.active = !this.active;
    this.update();
    return false;
  }

  lButtonGenerateClicked(ev) {
    ev.preventDefault();
    let $input = this.params.$element.find('input').first();
    $input.val(Password.random());
    this.active = true;
    this.update();
    $input.get(0).select();
    return false;
  }

  static random(length = 16) {
    let text = '';
    let possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  update() {
    let $button = this.params.$element.find('.js-btn-show').first();
    let $input = this.params.$element.find('input').first();
    let replacementClass = 'fe fe-eye' + (this.active ? '-off' : '');
    $button
      .find('i')
      .first()
      .attr('class', replacementClass);
    $input.attr('type', this.active ? 'text' : 'password');
  }
}

export default Password;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/Password.js